export const dataPreloader = {
    title_1: 'SIGUE ADELANTE SÓLO SI ERES MAYOR DE EDAD',
    button: 'ACCEDER',
    title_2: 'WELCOME TO',
    logo: '/assets/images/el-secreto-logo.svg',
}